import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectName, selectEmail, selectPhoneNumber } from '@store/order/selectors';



const CustomerInfo = () => {
	const { t } = useTranslation('forms');

	const name = useSelector(selectName);
	const email = useSelector(selectEmail);
	const phoneNumber = useSelector(selectPhoneNumber);

	return (
		<div className='order-summary-element'>

			<h2>{t('customerInfo.sectionLabel')}</h2>

			<div className='summary-grid'>
				
				<p>{t('inputLabels.fullName') + ':'}</p>
				<p>{name ? name : '-'}</p>
				
				<p>{t('inputLabels.email') + ':'}</p>
				<p>{email ? email : '-'}</p>

				<p>{t('inputLabels.phone') + ':'}</p>
				<p>{phoneNumber ? phoneNumber : '-'}</p>
			
			</div>

		</div>
	);
};

export default CustomerInfo;